import React from 'react'

import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

interface Props {
  className?: string
  onClick: (event: any) => void
}

function CloseButton({ className, onClick }: Props) {
  return (
    <IconButton className={className} onClick={onClick}>
      <CloseIcon />
    </IconButton>
  )
}

export default CloseButton
